export default "__VITE_ASSET__BQHbLwKC__"